const mimarProfit = {
    list:{
        filters:{
            fromDatePlaceholder:'من تاريخ',
            fromDateLabel:'من تاريخ',
            toDatePlaceholder:'إلى تاريخ',
            toDateLabel:'إلى تاريخ',
        }
    },
    expenseTable: {
        headlines: {
            expenseName: "اسم النفقات",
            expenseDate: "تاريخ النفقات",
            expenseAmount: "قيمة النفقات"
        },
        noDataDescription: "لا يوجد مصروفات بعد",
        addExpenseButton: "إضافة نفقات",
        addEditExpenseModal: {
            expenseNameEn: {
                label: "اسم النفقات (انجليزي)",
                placeholder: "ادخل اسم النفقات (انجليزي)",
            },
            expenseNameAr: {
                label: "اسم النفقات (عربي)",
                placeholder: "ادخل اسم النفقات (عربي)",
            },
            expenseDate: {
                label: "تاريخ النفقات",
                placeholder: "ادخل تاريخ النفقات",
            },
            expenseAmount: {
                label: "قيمة النفقات",
                placeholder: "ادخل قيمة النفقات",
            },
            title: "إضافة نفقات",
            addTitle: "إضافة نفقات",
            editTitle: "تعديل النفقات",
        },
        deleteExpenseModal: {
            title: "حذف النفقات",
            deleteConfirmationMsg: "هل أنت متأكد من رغبتك في حذف هذه النفقات؟ هذا الإجراء دائم ولا يمكن التراجع عنه"
        },
    },
    expenseInfo:
        {
            expenseTitle: "إجمالي ضريبة القيمة المضافة",
            expenseInfoText: "إجمالي قيمة ضريبة القيمة المضافة المخصومة من أرباح ميمار، وتمثل جميع مبالغ الضريبة المُحصّلة من المعاملات المُسوّاة.",
            label: "ريال",
        },
    profitCards: {
        netProfit: {
            name: "صافي الربح",
            infoText: "الربح المتبقي بعد خصم جميع النفقات وضريبة القيمة المضافة من إجمالي الأرباح المُسوّاة، ويُعبّر عن الأرباح الفعلية لميمار.",
        },
        settledProfit: {
            name: "الربح المُسوّى",
            infoText: "أرباح من المبالغ التي تم تحصيلها بالكامل وتسويتها بعد خصم نسبة ضريبة القيمة المضافة. هذه المبالغ متاحة بالفعل في حسابك",
        },
        unSettledProfit: {
            name: "المبلغ غير المُسوّى",
            infoText: "أرباح من المبالغ التي لا تزال قيد التسوية. سيتم إضافتها إلى إجمالي أرباحك بمجرد استلام مدفوعات مقدّمي الخدمات."
        },
        expenses: {
            name: "النفقات",
                infoText: " إجمالي التكاليف التشغيلية أو الخصومات المسجلة من قبل ميمار."
            }
    },
}
export default mimarProfit;